import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import {  Link, useLocation } from "react-router-dom";

import { MdQuestionAnswer, MdEdit, MdOutlineMoreVert, MdOutlineDeleteOutline, MdOutlineContentCopy } from "react-icons/md";

import { Img } from "../../../components/Elements";
import { AppContext } from "../../../Context";
import Fetch, { Loader, dateToText, GET } from "../../../inc/Fetch";

export default function GamesList({ v, selected, setselected }) {

    const { t } = useTranslation();
    const location = useLocation();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    function selectGame(id) {
        let ck = selected?.filter(r => r == id);

        if (ck?.length) {
            setselected(p => p?.filter(r => r != id));
            return false;
        }

        setselected(p => p?.length ? [...p, id] : [id]);
    }

    let ck = selected?.filter(r => r == v?._id);

    
    return (
        <div className={`taskList ${ck?.length ? 'ck' : ""}`}>

            {/* <Link to={`/sendGame/${v?._id}`} state={{ previousLocation: location }}> */}
            <a onClick={() => selectGame(v?._id)} >
                <Img src={`img/230x150/${v?.img}`} />
                <h5>{v?.name}</h5>
                <p>{v?.subject?.name}</p>
            </a>

            {/* {userinfo?.userlevel >= 3 && <ul>
                <Link to={`/sendGame/${v?._id}`} state={{ previousLocation: location }} className='btn'>{t("task_start_send")}</Link>
            </ul>} */}
            
        </div>
    )
}
